import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const FaqLink = props => /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
  iconProps: Object.assign({
    color: 'text-interactive-default',
    size: '200',
    alignWithText: true
  }, props.iconProps || {})
}));
export default FaqLink;